module.exports = __webpack_public_path__ + "static/media/studPokerFull.1d350f59.svg";